export const WEBINAR_TITLE = "AI agents as your marketing execution layer";
export const WEBINAR_DATE_LABEL = "Wednesday, July 1, 2026";
export const WEBINAR_FORM_DATE_LABEL = "Wednesday, July 1, 2026 at 19:30 CEST";
export const WEBINAR_TIME_LABEL = "19:30 CEST";
export const WEBINAR_DURATION_LABEL = "60 minutes";
export const WEBINAR_START_ISO = "2026-07-01T19:30:00+02:00";
export const WEBINAR_END_ISO = "2026-07-01T20:30:00+02:00";
export const WEBINAR_PUBLIC_URL = "https://agentreacher.com/webinar";
export const WEBINAR_ROOM_URL = "https://agentreacher.com/webinar/live";
export const WEBINAR_JOIN_URL = WEBINAR_ROOM_URL;
export const WEBINAR_FROM_EMAIL =
	process.env.WEBINAR_FROM_EMAIL || "AgentReacher <contact@agentreacher.com>";
export const WEBINAR_ADMIN_EMAIL =
	process.env.WEBINAR_ADMIN_EMAIL || "contact@agentreacher.com";
export const WEBINAR_REPLY_TO =
	process.env.WEBINAR_REPLY_TO || "contact@agentreacher.com";
export const WEBINAR_ICS_FILENAME =
	"agentreacher-marketing-execution-webinar.ics";
